export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_STATUS = 'SET_STATUS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_REQUESTS = 'SET_REQUESTS'
export const SET_SCHEMA = 'SET_SCHEMA'
export const SET_QUERY_TEMPLATES = 'SET_QUERY_TEMPLATES'
export const SET_CURRENT_TEMPLATE = 'SET_CURRENT_TEMPLATE'



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/types.js